"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_FILE_TYPES = exports.SUPPORTED_FILE_EXTENSIONS = exports.KEY_GEOJSON = exports.KEY_CSV = exports.FILE_TYPE_KEYS = exports.FILE_TYPE_DESCRIPTIONS = void 0;
const KEY_GEOJSON = 'GEOJSON';
exports.KEY_GEOJSON = KEY_GEOJSON;
const KEY_CSV = 'CSV';
exports.KEY_CSV = KEY_CSV;
const FILE_TYPE_KEYS = {
  [KEY_GEOJSON]: KEY_GEOJSON,
  [KEY_CSV]: KEY_CSV
};
exports.FILE_TYPE_KEYS = FILE_TYPE_KEYS;
const FILE_TYPE_DESCRIPTIONS = {
  [KEY_GEOJSON]: {
    fileType: KEY_GEOJSON,
    fileExtension: 'geojson'
  },
  [KEY_CSV]: {
    fileType: KEY_CSV,
    fileExtension: 'csv'
  }
};
exports.FILE_TYPE_DESCRIPTIONS = FILE_TYPE_DESCRIPTIONS;
const SUPPORTED_FILE_TYPES = Object.keys(FILE_TYPE_DESCRIPTIONS).map(k => FILE_TYPE_DESCRIPTIONS[k].fileType);
exports.SUPPORTED_FILE_TYPES = SUPPORTED_FILE_TYPES;
const SUPPORTED_FILE_EXTENSIONS = Object.keys(FILE_TYPE_DESCRIPTIONS).map(k => FILE_TYPE_DESCRIPTIONS[k].fileExtension);
exports.SUPPORTED_FILE_EXTENSIONS = SUPPORTED_FILE_EXTENSIONS;